import React, { useState, useEffect, useRef, Component } from 'react';
import Link from 'next/link'
import Image from 'next/image'
import { useSession } from 'next-auth/react'
import { signIn } from "next-auth/react"
import { KTPost, KTGet } from '@/kyna/lib/db';

import { EyeIcon, EyeOffIcon } from "@heroicons/react/solid";

import { useFormik } from 'formik';

import LoginSchema from '../../lib/validations/LoginSchema';

import InputForm from '../../forms/InputForm';
import { useRouter } from 'next/router';
import store from 'store2';

// import bcrypt from 'bcryptjs'

const UserSession = store.get('UserSession');

const getUsers = async (params) => {

    return await KTGet('/api/users', {
        limit: 1,
        username: params.username,
    })

}

const LoginIn = () => {
    const [isButtonClicked, setButtonClicked] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [loginFormMessage, setLoginFormMessage] = useState(null);
    const [loginFormMessageType, setLoginFormMessageType] = useState(null);
    const { data: session, status } = useSession()
    const router = useRouter()

    const submitHandler = async (values) => {
        setLoading(true)
        setLoginFormMessage(null)
        setLoginFormMessageType(null)
        const result = await signIn('credentials', {
            redirect: false,
            username: values.username,
            password: values.password
        })
        setLoading(false)
        if (result.error) {
            setLoginFormMessage(result.error)
            setLoginFormMessageType("text-red-400")
        } else {
            if (result.ok) {
                router.push('/app/account/onboarding')
            }

        }
    }
    const formik = useFormik({
        initialValues: {
            username: '',
            password: '',
        },
        validationSchema: LoginSchema,
        onSubmit: values => {
            //   alert(JSON.stringify(values, null, 2));
            submitHandler(values)
        },
    });

    const testBtnClick = () => {
        // alert("Button Clicked!")
        setButtonClicked(!isButtonClicked)
    };

    const [showPassword, setShowPassword] = useState("password");
    const [Password, setPassword] = useState("password");
    const [PasswordInput, setPasswordInput] = useState("");

    const handlePasswordChange = (evnt) => {
        setPasswordInput(evnt.target.value);
    }
    const togglePassword = () => {
        if (Password === "password") {
            setPassword("text")
            return;
        }
        setPassword("password")
    }
    return (
        <>
            <form
                onSubmit={formik.handleSubmit}
                autoComplete={"off"}
            >
                <InputForm
                    type="text"
                    id="username"
                    name="username"
                    placeholder="Username *"
                    withFormik={true}
                    formik={formik}
                />
                {/* <InputForm
                    type={Password}
                    id="password"
                    name="password"
                    placeholder="Password"
                    withFormik={true}
                    formik={formik}
                /> */}
                
                <div className='relative bg-slate-300 rounded'>
                    <input
                        type={Password}
                        id="password"
                        name="password"
                        onChange={(e) => {
                            handlePasswordChange
                            formik.setFieldValue("password", e.target.value);
                        }}
                        placeholder="Password *"
                        className="form-control"
                    />
                    <i onClick={togglePassword} className="absolute top-[17px] right-3">
                        {Password === "password" ? (
                            <EyeOffIcon onClick={() => {setShowPassword("text")}} className="col-span-1 h-5 w-5 text-blue-500 cursor-pointer" />
                        ) : (
                            <EyeIcon onClick={() => {setShowPassword("password")}} className="col-span-1 h-5 w-5 text-blue-500 cursor-pointer" />
                        )}
                    </i>
                </div>
                <div className="help-block text-red-400 text-xs">
                            {formik.touched.password &&
                            formik.errors.password ? (
                              <div>{formik.errors.password}</div>
                            ) : null}
                          </div>

                {
                    loginFormMessage != '' ? (
                        <div className={`mt-1 mb-2 ${loginFormMessageType}`}>
                            {loginFormMessage}
                        </div>
                    ) : null
                }
                
                <div className="">
                    <p className='text-sm leading-relaxed border-b border-b-gray-300 mb-4 py-5'>
                        By continuing, you agree to the <Link href="/terms-and-conditions"><a className='underline'>Terms and Conditions</a></Link> and confirm that you have read the <Link href="/privacy-policy"><a className='underline'>Privacy Policy</a></Link>
                    </p>
                </div>

                <div className="grid sm:grid-cols-4 grid-cols-1 gap-y-2 sm:gap-x-3 gap-x-0 items-center">
                    <div className="col-span-3">
                        <div className="form-group">
                            <Link href="/account/forgot_password"><a className=' text-blue-600'>Forgot password / username</a></Link>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <div className="form-group text-center">
                            <button type="submit" disabled={isLoading ? true : false} className="btn btn-secondary rounded-full w-full">
                                {
                                    !isLoading ? 'Login' : (
                                        <>
                                            <span className='relative'>
                                                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                            </span>
                                        </>
                                    )
                                }
                            </button>
                        </div>
                    </div>
                </div>

            </form>

            {/* {
                isButtonClicked == true ? (<h4>Hello, Button Clicked!</h4>) : (<p>Please, click button!</p>)
            }

            <button className='btn' onClick={testBtnClick}>
                test button
            </button> */}

        </>

    );
};

export default LoginIn;
